export const AUTH_LOGIN_CONTEXT_KEY = 'auth_login_context';
export const AUTH_USERDATA_KEY = 'auth_userdata';
